import { createAsyncThunk, createSlice, createSelector } from '@reduxjs/toolkit';
import authAxios from "utils/authAxios";

// Thunks
export const fetchStrategyPerformance = createAsyncThunk(
  'performance/fetchStrategyPerformance',
  async (strategyId) => {
    const response = await authAxios.get(`/strategy/performance/${strategyId}/`);
    return {
      strategyId,
      data: response.data
    };
  }
);

// Initial state - focus exclusively on performance data points for charts
const initialState = {
  performanceByStrategy: {}, // Daily/historical data points for charts
  loading: false,
  error: null,
};

// Slice
export const performanceSlice = createSlice({
  name: 'performance',
  initialState,
  reducers: {
    // No custom reducers needed
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStrategyPerformance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStrategyPerformance.fulfilled, (state, action) => {
        const { strategyId, data } = action.payload;
        
        // Store performance data by strategy ID
        state.performanceByStrategy[strategyId] = data;
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchStrategyPerformance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch performance data';
      });
  },
});

// Selectors
export const selectStrategyPerformanceData = createSelector(
  [state => state.performance.performanceByStrategy, (_, strategyId) => strategyId],
  (performanceByStrategy, strategyId) => performanceByStrategy[strategyId] || []
);

export default performanceSlice.reducer; 